import { RequiredPresignParams } from '../config';

export const hasAllRequiredPresignParams = (
  params: RequiredPresignParams,
): boolean => Object.values(params).every(Boolean);
